import { useQuery } from "@tanstack/react-query";
import { getAccount } from "./api";
import { useAuth } from "./AuthContext";

// Account-settings favourite teams per league, in the user's order (1st, 2nd, 3rd…).
// Separate from the nav / per-page team sort.
export function useAccountFavs() {
    const { user } = useAuth();
    const { data } = useQuery({ queryKey: ["account"], queryFn: getAccount, enabled: !!user, staleTime: 60 * 1000 });
    const p = data?.profile;
    const f = p?.fav_teams || {};
    return {
        pwhl: f.pwhl ?? (p?.main_team_id ? [p.main_team_id] : []),
        nhl: f.nhl ?? (p?.main_nhl_team_id ? [p.main_nhl_team_id] : []),
        international: f.international || [],
        ncaa: f.ncaa || [],
    };
}

// Sort key: 0 = 1st favourite, 1 = 2nd … ; non-favourites last.
export const favRankOf = (list, ids) => {
    const r = ids.map((x) => list.indexOf(x)).filter((i) => i >= 0);
    return r.length ? Math.min(...r) : 999;
};
